<template>
  <!-- 录带看   弹屏 -->
  <a-modal
    v-model="isLook"
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    :closable="false"
    :width="700"
    centered
  >
    <div class="content-look">
      <div class="title">
        <a-icon @click="isLookFn" style="font-size: 16px; cursor: pointer" type="close" />
        <span>添加带看</span>
        <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="lookOK">提交</span>
      </div>
      <div style="margin-top: 20px">
        <span style="margin-right: 10px; font-weight: bold">带看时间</span>
        <a-date-picker placeholder="请选择时间" :disabled-date="disabledLookDate" @change="getLookTime">
        </a-date-picker>
      </div>
      <textarea
        class="textarea"
        v-model="takeLookRecordData.takeLookContent"
        :maxlength="100"
        placeholder="请输入带看内容"
      ></textarea>
      <div class="chooseBtn" @click="isLookList = true" style="cursor: pointer">
        <a-icon style="font-size: 18px; margin-right: 10px" type="plus-circle" />
        <span>选择房源</span>
      </div>

      <div :class="{ houseListBox: isScroll }" v-if="houseInfoList">
        <div v-for="(v, i) in houseInfoList" :key="v.id">
          <a-row class="house">
            <a-col :span="6">
              <img
                width="150"
                height="100"
                v-if="v.houseInfoImgVo && v.houseInfoImgVo.thisShopList"
                :src="v.houseInfoImgVo.thisShopList[0].url"
                alt=""
              />
              <img width="150" height="100" v-else src="@/assets/images/nodataImg.svg" alt="" />
            </a-col>
            <a-col :span="17" style="padding-left: 10px">
              <h4 style="font-weight: 700; font-size: 16px">{{ v.shopName }}</h4>
              <div>
                <span style="margin-right: 15px; color: #000">{{ v.businessDistrictName }} </span>
                <span style="margin-right: 15px; color: #000">{{ v.streetName }} </span>
                <span style="margin-right: 15px; color: #000">{{ v.grossFloorArea }} m²</span>
                <span style="margin-right: 15px; color: #000">{{ v.houseFloor }} 1/{{ v.floorTotal }} 层</span>
                <span style="color: #ff7202; font-weight: 700">{{ v.rentFee }} 元/月</span>
              </div>
              <span style="color: #000">编号 {{ v.houseCode }}</span>
            </a-col>
            <a-col :span="1">
              <a-icon style="color: #ff7202; line-height: 100px" type="minus-circle" @click="delItem(i)" />
            </a-col>
          </a-row>
        </div>
      </div>

      <!-- 房源列表弹窗组件 -->
      <template v-if="type === 'tenants'">
        <look-list :isLookList="isLookList" houseStatus="1" @closeModal="isLookList = $event" @dataList="getListData"></look-list>
      </template>
      <template v-else>
        <sell-look-list :isLookList="isLookList" houseStatus="1" @closeModal="isLookList = $event" @dataList="getListData"></sell-look-list>
      </template>
    </div>
  </a-modal>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import sell_touristApi from '@/api/system/tourist/sell_tourist.js'

import LookList from '@/components/modal/LookList.vue'
import sellLookList from '@/components/modal/sellLookList.vue'

export default {
  components: {
    LookList,
    sellLookList
  },
  props: {
    userId: {
      type: [Number, String],
      default: ''
    },
    houseInfoList: {
      type: Array,
      default: () => []
    },
    // sale 售 tenants 租
    type: {
      type: String,
      default: ''
    }
  },
  watch: {
    houseInfoList: {
          handler (val) {
            if (this.houseInfoList && this.houseInfoList.length > 3) {
              this.isScroll = true
            } else {
              this.isScroll = false
            }
          },
          deep: true,
          immediate: true
    }
  },
  data () {
      return {
        isLook: false,
        // 新增带看记录参数
        takeLookRecordData: {
          houseId: [], //	房源ids
          resourceId: this.userId, // 来源ID
          takeLookContent: '', // 带看内容
          takeLookTime: '', // 带看时间
          rentSaleType: '1' // 租售类型rent_sale_type  1租 2售
        },
        isLookList: false,
        isScroll: false // 带看弹窗是否滚动
      }
  },
  methods: {
    open () {
      this.isLook = true
    },
    isLookFn () {
      this.takeLookRecordData.takeLookContent = ''
      this.takeLookRecordData.takeLookTime = ''
      // this.houseInfoList = []
      this.isLook = false
      this.$emit('resetFile')
    },
    disabledLookDate (current) {
      return current && current > this.$moment().endOf('day')
    },
    // 获取带看时间
    getLookTime (m, val) {
      this.takeLookRecordData.takeLookTime = val
    },
     // 录带看===>提交
    lookOK () {
      const ids = this.houseInfoList.map((v) => {
        return v.id
      })
      this.takeLookRecordData.houseId = ids
      if(this.type == 'sale'){
        this.takeLookRecordData.rentSaleType = '2'
      }else {
        this.takeLookRecordData.rentSaleType = '1'
      }
      this.takeLookRecordAdd()
    },
    // 新增带看记录
    takeLookRecordAdd () {
      this.takeLookRecordData.resourceId = this.$route.query.id
      // console.log(this.takeLookRecordData)
      if (!this.takeLookRecordData.houseId.length) {
        this.$message.warning('需选择带看房源')
        return
      }
      const keys = Object.keys(this.takeLookRecordData)
      for (let index = 0; index < keys.length; index++) {
        if (!this.takeLookRecordData[keys[index]]) {
          this.$message.warn('您还未填写完整！')
          return
        }
      }

      touristApi.takeLookRecordAdd({ ...this.takeLookRecordData }).then((res) => {
        if (res.code === 200) {
          this.$message.success('新增带看记录')
          // this.getRecordList()
          // this.getUserInfo()
          this.$emit('onSuccess')
          this.isLookFn()
        }
      })
    },
    // 删除小项
    delItem (item) {
      this.$emit('delItem', item)
    },
    getListData (data) {
      this.$emit('getListData', data)
    }

  }
}
</script>

<style lang="less" scoped>
//带看
.content-look {
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .titleIntention {
    min-height: 100px;
  }
  .textarea {
    margin-top: 20px;
    width: 100%;
    height: 160px;
    outline: none;
    border-radius: 10px;
    border-color: #f1f2f3;
    padding: 10px;
    margin-bottom: 20px;
    resize: none;
    overflow: hidden;
  }
  .chooseBtn {
    display: flex;
    align-items: center;
    color: #33c171;
  }

  .houseListBox {
    height: 400px;
    overflow-y: scroll;
  }
  .house {
    margin-top: 10px;
    padding: 10px 14px;
    width: 100%;
    height: 120px;
    background-color: #f9f7fb;
    border-radius: 10px;
    .img {
      width: 100%;
      height: 100px;
      border-radius: 8px;
      background-color: blue;
    }
  }
}
</style>
